import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

// Admin review of the OTS service-fee receipts on cash bookings. The token is
// read at call time, not at module load, so a fresh login is always picked up.
const authHeaders = () => {
  const token =
    sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");
  return { Authorization: `Bearer ${token}` };
};

const messageOf = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

export const GetOtsFeeReceipts = createAsyncThunk(
  "otsFeeReceipts/list",
  async ({ status = "pending" } = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/ots-fee-receipts`, {
        params: { status },
        headers: authHeaders(),
      });
      return res.data;
    } catch (error) {
      return rejectWithValue({
        message: messageOf(error, "Failed to load OTS fee receipts"),
      });
    }
  }
);

export const VerifyOtsFeeReceipt = createAsyncThunk(
  "otsFeeReceipts/verify",
  async (requestId, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/admin/ots-fee-receipts/${requestId}/verify`,
        {},
        { headers: authHeaders() }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue({
        message: messageOf(error, "Failed to verify the receipt"),
      });
    }
  }
);

export const RejectOtsFeeReceipt = createAsyncThunk(
  "otsFeeReceipts/reject",
  async ({ requestId, reason }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/admin/ots-fee-receipts/${requestId}/reject`,
        { reason },
        { headers: authHeaders() }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue({
        message: messageOf(error, "Failed to reject the receipt"),
      });
    }
  }
);

const OtsFeeReceiptsSlice = createSlice({
  name: "otsFeeReceipts",
  initialState: {
    loading: false,
    items: [],
    counts: { not_submitted: 0, pending: 0, verified: 0, rejected: 0, cancelled: 0 },
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOtsFeeReceipts.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(GetOtsFeeReceipts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload?.data || [];
        state.counts = { ...state.counts, ...(action.payload?.counts || {}) };
      })
      .addCase(GetOtsFeeReceipts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to load receipts";
      });
  },
});

export default OtsFeeReceiptsSlice.reducer;
